/*eslint no-magic-numbers: ["error", { "ignore": [0] }]*/
/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import capitalizeString from 'utils/capitalize'
import RejectIcon from 'assets/icons/reject-icon'
import { reassessmentTriggerReasons } from 'constants/reassessmentTriggerReasons'
import Tooltip from 'components/Tooltip'

import { RedListCategoryStatus, TableNotQualifyIconWrapper } from './style'
import capitalizeFirstLetterString from 'utils/capitalizeFirstLetter'
import { specieAssessmentParameterType } from 'constants/speciesParameterType'

export const renderRedListCategoryStatus = (status) => {
  const color = {
    EX: '#FFFFFF',
    EW: 'rgba(84, 35, 68, 0.3)',
    CR: 'rgba(216, 30, 5, 0.5)',
    EN: 'rgba(252, 127, 63, 0.6)',
    VU: 'rgba(249, 232, 20, 0.6)',
    LR: 'rgba(226, 211, 105, 0.8)',
    NT: 'rgba(204, 226, 38, 0.6)',
    LC: 'rgba(96, 198, 89, 0.6)',
    DD: '#D1D1C6'
  }

  return (
    <RedListCategoryStatus color={color[status]}>
      <FormattedMessage id={status} />
    </RedListCategoryStatus>
  )
}

const tooltipXOffset = 0
const tooltipYOffset = -16

const formattedRejectIconTooltipHint = (item) => {
  return item.map((element) => {
    return reassessmentTriggerReasons.find((elementId) => {
      return elementId.id === element
    }).name
  })
}

const notQulifyIcon = (hint) => {
  return (
    <Tooltip
      kbaCriteria={true}
      style={{ zIndex: 1000 }}
      placement='top'
      trigger={['hover']}
      align={{ offset: [tooltipXOffset, tooltipYOffset] }}
      overlay={{ label: 'nonQualifying', infoTooltip: formattedRejectIconTooltipHint(hint).join(', ') }}
    >
      <TableNotQualifyIconWrapper>
        <RejectIcon />
      </TableNotQualifyIconWrapper>
    </Tooltip>

  )
}

export const makeCalculationRow = (calculationData, site, disabled, canSeeSiteIBASitesManagement, shouldShowSiteIBAData) => {
  let rows = [];
 
  calculationData.forEach((item) => {
    let qualifies;
    if (disabled) {
      qualifies = item.triggerReasonId ? item.triggerReasonId.some((element) => {
        // eslint-disable-next-line no-magic-numbers
        return element === 1;
      }) : true;
    } else {
      qualifies = site.reassessmentFlag ? item.triggerReasonId.some((element) => {
        // eslint-disable-next-line no-magic-numbers
        return element === 1;
      }) : true;
    }
    const isAves = item.taxonGroup === 'Aves';
    if (site.kbaCriteria) {
      site.kbaCriteria.forEach(criteria => {
        if (criteria.scientificName === item.scientificName) {
          const parameters = criteria.speciesAssesmentParametersDisplay || [];
          const assessmentParameterTypeIds = new Set(); // Use a set to avoid duplicates
          parameters.forEach(parameter => {
            assessmentParameterTypeIds.add(parameter.SiteAssesmentParameterTypeId);
          });
          assessmentParameterTypeIds.forEach(parameterTypeId => {
            const parameterLabel = specieAssessmentParameterType.find(param => param.id === parameterTypeId)?.name;
            const key = `${item.taxonGroup}-${item.season?.name || '-'}-${item.scientificName}-${parameterLabel}`;
            if (item.siteAssesmentParameterTypeId != null) {
              item.siteAssesmentParameterTypeId.forEach(itemParameterTypeId => {
                if (itemParameterTypeId == parameterTypeId) {
                  const assess = parameters.find(param => param.
                    SiteAssesmentParameterTypeId === parameterTypeId)
                  const population = (assess.bestSite / assess.bestGlobal * 100).toFixed(2);
                  // Check if a row with the same assessment parameter already exists
                  if (!rows.some(row => row.key === key)) { // Using `some` for a more direct check
                    rows.push({
                      key: key,
                     taxonGroup: `${capitalizeString(item.taxonGroup)}`,
                      season: qualifies ? capitalizeString(item.season?.name || '-') : '-',
                      scientificName: `${capitalizeFirstLetterString(item.scientificName)}`,
                      commonName: `${capitalizeFirstLetterString(item.commonName)}`,
                      iucnStatus: renderRedListCategoryStatus(item.iucnStatus),
                      reproductiveUnits: qualifies ? item.reproductiveUnits : '-',
                      population: qualifies ? `${(population === Number.NEGATIVE_INFINITY) || (population === Number.POSITIVE_INFINITY) || (isNaN(population)) ? '-' : `${population}%`}` : '-',
                      kbaCriteria: qualifies ? `${capitalizeString(item.kbaCriteria)}` : notQulifyIcon(item.triggerReasonId),
                      ibaCriterias: canSeeSiteIBASitesManagement(site) ? shouldShowSiteIBAData(site,
                        isAves ? capitalizeString(item.ibaCriterias) : null,
                        'sitesManagement'
                      ) : null,
                      assessmentParameter: capitalizeFirstLetterString(parameterLabel) || '-'
                    });
                  }
                } 
              })
            }
            else {
              const assess = parameters.find(param => param.
                SiteAssesmentParameterTypeId === parameterTypeId)
              const population = (assess.bestSite / assess.bestGlobal * 100).toFixed(2);
              // Check if a row with the same assessment parameter already exists
              if (!rows.some(row => row.key === key)) { // Using `some` for a more direct check
                rows.push({
                  key: key,
                  taxonGroup: `${capitalizeString(item.taxonGroup)}`,
                  season: qualifies ? capitalizeString(item.season?.name || '-') : '-',
                  scientificName: `${capitalizeFirstLetterString(item.scientificName)}`,
                  commonName: `${capitalizeFirstLetterString(item.commonName)}`,
                  iucnStatus: renderRedListCategoryStatus(item.iucnStatus),
                  reproductiveUnits: qualifies ? item.reproductiveUnits : '-',
                  population: qualifies ? `${(population === Number.NEGATIVE_INFINITY) || (population === Number.POSITIVE_INFINITY) || (isNaN(population)) ? '-' : `${population}%`}` : '-',
                  kbaCriteria: qualifies ? `${capitalizeString(item.kbaCriteria)}` : notQulifyIcon(item.triggerReasonId),
                  ibaCriterias: canSeeSiteIBASitesManagement(site) ? shouldShowSiteIBAData(site,
                    isAves ? capitalizeString(item.ibaCriterias) : null,
                    'sitesManagement'
                  ) : null,
                  assessmentParameter: capitalizeFirstLetterString(parameterLabel) || '-'
                });
              }
            }
          });
        }
      });
    }
  });
 
  return rows;
};




export const makeCalculationsColumns = (showIBAColumn = false) => {

  const headers = [
    {
      id: 'taxonGroup',
      header: (
        <>
          <FormattedMessage id='taxonGroup' />
        </>
      ),
      accessorKey: 'taxonGroup',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'season',
      header: (
        <>
          <FormattedMessage id='season' />
        </>
      ),
      accessorKey: 'season',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'scientificName',
      header: (
        <>
          <FormattedMessage id='scientificName' />
        </>
      ),
      accessorKey: 'scientificName',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'commonName',
      header: (
        <>
          <FormattedMessage id='commonName' />
        </>
      ),
      accessorKey: 'commonName',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'iucnStatus',
      header: (
        <>
          <FormattedMessage id='iucnStatus' />
        </>
      ),
      accessorKey: 'iucnStatus',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'assessmentParameter',
      header: (
        <>
          <FormattedMessage id='assessmentParameter' />
        </>
      ),
      accessorKey: 'assessmentParameter',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'reproductiveUnits',
      header: (
        <>
          <FormattedMessage id='reproductiveUnits' />
        </>
      ),
      accessorKey: 'reproductiveUnits',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'population',
      header: (
        <>
          <FormattedMessage id='population' />
        </>
      ),
      accessorKey: 'population',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaCriteria',
      header: (
        <>
          <FormattedMessage id='kbaCriteria' />
        </>
      ),
      accessorKey: 'kbaCriteria',
      style: {
        width: '10%'
      },
      cell: ({ getValue }) => getValue()
    }
  ]

  if (showIBAColumn) {
    headers.push({
      id: 'ibaCriterias',
      header: (
        <>
          <FormattedMessage id='ibaCriterias' />
        </>
      ),
      accessorKey: 'ibaCriterias',
      cell: ({ getValue }) => getValue()
    })
  }

  return headers
}
